var createCookieString = function (cookieObject) {
    var cookies = Object.entries(cookieObject).reduce(function (cookies, _a) {
        var key = _a[0], value = _a[1];
        return value ? "" + cookies + key + "=" + value + "; " : cookies;
    }, '');
    if (cookies.length === 0)
        return '';
    return cookies.slice(0, cookies.length - 2);
};
export default createCookieString;
//# sourceMappingURL=createCookieString.js.map